import { useTranslation } from 'react-i18next';

import { LogoutButton } from '../logout-button';

import { ResponsiveMenuProps } from './types';
import { NavigationLink } from './navigation-link';
import { LanguageButton } from './language-button';

export const ResponsiveMenu = ({
  links,
  onClick,
  pathname,
  userLinks,
  isGuestUser,
}: ResponsiveMenuProps) => {
  const { t } = useTranslation(['header']);
  return (
    <div className="bg-accent-gradient-primary-primary absolute top-0 left-0 flex h-screen w-full pt-12 md:pt-16">
      <div className="flex min-h-0 w-full flex-col overflow-y-auto py-4 md:py-6">
        <div>
          {!isGuestUser &&
            userLinks?.map((item) => (
              <NavigationLink
                key={item.label}
                href={item.href}
                variant="mobile"
                label={t(item.i18nKey)}
                external={item.external}
                asButton={item.asButton}
                isActive={pathname === item.href}
                onClick={() => onClick(item.asButton)}
              />
            ))}
          <LanguageButton buttonClassName="h-[54px] px-4 md:px-6" />
        </div>
        <div>
          <div className="bg-light-gradient-primary mb-4 h-[1.5px]"></div>
          {links?.map((item) => (
            <NavigationLink
              key={item.label}
              href={item.href}
              variant="mobile"
              label={t(item.i18nKey)}
              external={item.external}
              asButton={item.asButton}
              isActive={pathname === item.href}
              onClick={() => onClick(item.asButton)}
            />
          ))}
        </div>
        <div className="px-4 py-2 md:px-6">
          <LogoutButton
            className="w-full md:w-auto"
            buttonClassName="bg-white-primary hover:bg-white-hover active:bg-white-active text-black-primary active:text-black-primary"
          />
        </div>
      </div>
    </div>
  );
};
